import { useResponsive } from '@/hooks';
import { ResponsiveCollection } from '@/interfaces';
import { useEffect, useState } from 'react';

const useOverflowing = ({
  ref,
  limit = 1,
  lineHeight = 22, // Body Text Small
}: {
  ref: React.RefObject<HTMLDivElement>;
  limit?: number;
  lineHeight?: number;
}) => {
  const [overflowing, setOverflowing] = useState(false);
  const { isDesktop } = useResponsive([ResponsiveCollection.Desktop]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: ref.current is intentional — triggers recalculation when DOM node changes
  useEffect(() => {
    if (ref.current) {
      const isOverflowing = ref.current.scrollHeight > limit * lineHeight;
      setOverflowing(isOverflowing);
    }
  }, [ref.current, limit, lineHeight, isDesktop]);

  return overflowing;
};

export default useOverflowing;
